import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { GET_USER_IN_2N } from '../get-user';
import { useModal } from '../../../store/modals';
import { GET_PAIRING_STATUS } from '../get-pairing-status';
import { updateUserIn2nAPI } from './api';

export function useUpdateUserIn2n(user) {

  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal, isModalOpen } = useModal();

  const isConfirmationModalOpen = isModalOpen('ConfirmationModal');

  const { mutateAsync, mutate, isLoading, isSuccess, isError } = useMutation(
    (data) => updateUserIn2nAPI(user, data),
    {
      onSuccess: () => {

        queryClient.invalidateQueries([GET_USER_IN_2N, tenantId, user.Account.Email, user?.isSuspended]);
        queryClient.invalidateQueries([GET_PAIRING_STATUS, tenantId, user.Account.Email]);

        if (!isConfirmationModalOpen) {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'success',
              description: 'updateUserSuccess',
            },
          });
        }

      },
      onError: (error) => {
        if (error.errorMessage === 'No pairing devices available for this user') {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'error',
              description: 'noPairingDevicesErrorMessage',
            },
          });
        } else {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'error',
              description: 'genericErrorMessage',
            },
          });
        }
      },
    },
  );

  return {
    mutateAsync,
    mutate,
    isLoading,
    isSuccess,
    isError,
  };
}

